<ycn-modal-base [open]="open" (closeModalHandler)="closeModal()">
    <ycn-simple-modal-header [header]="'Select Financial Metric'" (closeModalHandler)="closeModal()"></ycn-simple-modal-header>
    <div class="modal-body">
        <div class="modal-section form-row">
            <ycn-icon-search-autocomplete
                    [searchType]="searchType"
                    [defaultOnly]="defaultOnly"
                    (submitHandler)="submitModalAutocomplete($event)">
            </ycn-icon-search-autocomplete>
        </div>
        <ycn-single-metric-by-category-list
                [selectedMetricName]="selectedMetricName"
                [categories]="categories"
                (submitMetricHandler)="submitModal($event)">
        </ycn-single-metric-by-category-list>
    </div>
    <div class="modal-footer"></div>
</ycn-modal-base>

<ycn-feature-needed></ycn-feature-needed>
